import Grid, { type GridProps, type GridSize } from '@commons/containers/Grid';
import PageBuilder from '@commons/pagebuilder';

import type { DrupalInsightsView } from '.';
import styles from './Cards.module.scss';

/**
 * Cards display of the insights view.
 *
 * Renders a set of insights as cards.
 * On mobile, the content overflows to the right.
 */

const CardsDisplay = ({ content, settings }: DrupalInsightsView) => {
  const limit = settings.limit ? parseInt(settings.limit, 10) : 4;

  const columns: GridProps['columns'] = (limit >= 4 ? 4 : limit) as GridSize;

  return (
    <Grid gap="md" columns={columns} className={styles.insights}>
      {content.map(PageBuilder.renderNode)}
    </Grid>
  );
};

export default CardsDisplay;
